import ModeTradePlugin from '../ModeTradePlugin';
import type { PluginParameters } from '../types';

export default function modeTrade(params: PluginParameters) {
  return new ModeTradePlugin(params);
}
